import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSubscription, clearSubscription } from '@Redux/subscription/subscriptionActions';

const VALID_STATUSES = ['ACTIVE', 'TRIALING', 'CREATED'];

const parseDateSafe = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed;
};

export const useReduxSubscription = () => {

    const dispatch = useDispatch();
    const subscription = useSelector((state) => state.subscription.currentSubscription);

    const setCurrentSubscription = useCallback(
        (subscriptionData) => {
            dispatch(setSubscription(subscriptionData));
        },
        [dispatch]
    );

    const clearCurrentSubscription = useCallback(
        () => {
            dispatch(clearSubscription());
        },
        [dispatch]
    );

    const subscriptionStatus = subscription?.status;
    const currentPeriodEnd = parseDateSafe(subscription?.currentPeriodEnd);
    const gracePeriodEnd = parseDateSafe(subscription?.gracePeriodEnd);
    const now = new Date();

    const isCancelledButStillInAccessWindow =
        subscriptionStatus === 'CANCELLED' &&
        !!currentPeriodEnd &&
        currentPeriodEnd > now;
    const isHaltedButWithinGracePeriod =
        subscriptionStatus === 'HALTED' &&
        !!gracePeriodEnd &&
        gracePeriodEnd > now;
    const isSubscriptionValid =
        !!subscription &&
        (VALID_STATUSES.includes(subscriptionStatus) || isCancelledButStillInAccessWindow || isHaltedButWithinGracePeriod);

    return {
        subscription,
        isSubscriptionValid,
        isHaltedButWithinGracePeriod,
        setCurrentSubscription,
        clearCurrentSubscription,
    };
};
